import React, { FC, useEffect } from 'react';

import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { REPORT_TYPES, report } from '@adsk/exo-skeleton-api';

import { EXO_SKELETON_SCOPE_NAME } from '../../consts';
import { REPORT_EVENT_TYPES } from '../../utils/monitoring';

type RedirectProps = {
  from: string;
  to: string;
};

const Redirect: FC<RedirectProps> = ({ from, to }) => {
  useEffect(() => {
    if (from) {
      void report({
        scope: EXO_SKELETON_SCOPE_NAME,
        type: REPORT_TYPES.warning,
        value: new Error(`Access to deprecated route detected: ${from}`),
        context: {},
        UNSAFE__globalContext: {
          from,
          to,
          type: REPORT_EVENT_TYPES.DEPRECATED_ROUTE_OR_REDIRECT,
        },
      });
    }
  }, [from, to]);

  return <Navigate to={to} replace />;
};

Redirect.propTypes = {
  /** path to redirect from */
  from: PropTypes.string.isRequired,
  /** path to redirect to */
  to: PropTypes.string.isRequired,
};

export default Redirect;
